module.exports = __webpack_public_path__ + "img/nav-arrow.53a7baa0.svg";